<template>
    <div id="competences" v-touch:swipe="swipeHandler"
    :style="{
        background: colors.theme == 'dark' ? '#000' : '#ffffff',
        color: colors.theme == 'dark' ? '#fff' : '#000'
    }">
        <!-- <scenary-options></scenary-options> -->
        <Navbar></Navbar>
        <report-header :pageNumberIndicator="pageNumberIndicator" backRoute="/report/graphic" :title="componentsData.headerTitle" :backTo="componentsData.backTo" :backOption="componentsData.backOption"></report-header>
        <div class="container-competences">
            <div class="accordion" 
                :class="[accordion.open == 'open-body' ? 'open' : 'closed', colors.theme == 'dark' ? 'dark' : 'light']"
                 v-for="(accordion, index) in accordionData" 
                 :key="index" 
                 @click="toogleAccordion(accordion)"
                 :style="{ 'height' : calcHeight(accordion), 'transition-duration' : '500ms', 'border-top': colors.theme == 'dark' ? '1px solid #364149' : '1px solid #ccc'}"
                 >
                <accordion-content 
                :title="accordion.title"
                :text="accordion.text"
                :open="accordion.open"
                :index="index"
                ></accordion-content>
            </div>
            <report-pagination
                :activeBefore="pagination.activeBefore"
                :activeNext="pagination.activeNext"
                :nextRoutePagination="pagination.nextRoutePagination"
                :beforeRoutePagination="pagination.beforeRoutePagination"
            ></report-pagination>
        </div>
        <!-- <button-next :title="componentsData.buttonNextTitle" nextRoute="/game-over"></button-next> -->
    </div>
</template>

<script>
import Navbar from "../../components/shared/header/Navbar";
import Header from '../../components/shared/report/Header'
import ScenaryOptions from '../../components/shared/report/ScenaryOptions'
import AccordionContent from '../../components/shared/report/accordion/AccordionContent'
import ReportPagination from '../../components/shared/report/ReportPagination'
export default {
    name: 'Competences',
    props:[],
    components:{
        'report-header': Header,
        'scenary-options': ScenaryOptions,
        'report-pagination': ReportPagination,
        AccordionContent,
        Navbar
    },
    data(){
        return{
            background: '',
            colors:{},
            componentsData: {
                headerTitle: this.$t("views.report.competences.componentsData.headerTitle"),
                backOption: true,
                backTo: this.$t("views.report.competences.componentsData.backTo"),
                buttonNextTitle: this.$t("views.report.competences.componentsData.buttonNextTitle"),
            },
            pagination:{
                activeBefore: true,
                activeNext: true,
                beforeRoutePagination: 'graphic',
                nextRoutePagination: '/feedback'
            },
            pageNumberIndicator: 3,
            reportData: JSON.parse(localStorage.getItem('report')),
            accordionData : [
            {
                title : [
                    {
                        title : this.$t("views.report.competences.componentsData.accordionDataTitle[0]"),
                        competence : true
                    },
                    {
                        title : this.$t("views.report.competences.componentsData.accordionDataTitle[1]"),
                        competence : false
                    }
                ],
                text : '',
                open : 'open-body'
            },
            {
                title : [
                    {
                        title : this.$t("views.report.competences.componentsData.accordionDataTitle[2]"),
                        competence : true
                    },
                    {
                        title : this.$t("views.report.competences.componentsData.accordionDataTitle[3]"),
                        competence : false
                    },
                ],
                text : '',
                open : 'closed-body'
            },
            {
                title : [
                    {
                        title : this.$t("views.report.competences.componentsData.accordionDataTitle[4]"),
                        competence : true
                    },
                    {
                        title : this.$t("views.report.competences.componentsData.accordionDataTitle[5]"),
                        competence : false
                    },
                ],
                text : '',
                open : 'closed-body'
            },
            {                
                title : [
                    {
                        title : this.$t("views.report.competences.componentsData.accordionDataTitle[6]"),
                        competence : true
                    },
                    {
                        title : this.$t("views.report.competences.componentsData.accordionDataTitle[7]"),
                        competence : false
                    },
                ],
                text : '',
                open : 'closed-body'
            },
            {
                title : [
                    {
                        title : this.$t("views.report.competences.componentsData.accordionDataTitle[8]"),
                        competence : true
                    },
                    {
                        title : this.$t("views.report.competences.componentsData.accordionDataTitle[9]"),
                        competence : false
                    },
                ],
                text : '',
                open : 'closed-body'
            },


        ],
        accordionText: this.$t("views.report.competences.componentsData.accordionText")
        
        }
    },

    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
        Boolean(localStorage.getItem("feedback")) ? this.pagination.nextRoutePagination = '/dashboard' : this.pagination.nextRoutePagination = '/feedback'
        // console.log(this.reportData.competencesArray)
        this.applyTextCompetence()
        if(this.open == 'open-body') this.background = 'transparent'
        if(this.colors.theme == 'dark' && !this.open == 'open-body') this.background =  '#0a1721'
        if(this.colors.theme == 'light' && !this.open == 'open-body') this.background =  '#f0f0f0'        
        // 'background-color' : colors.theme == 'dark' && accordion.open ? '#15212a' : '#f0f0f0' 

    },
    methods : {
       toogleAccordion(accordion){
           this.closedAllAccordion()
           if(accordion.open == 'open-body'){
                accordion.open = 'closed-body'
            }else{
                accordion.open = 'open-body'
            }
       },
       closedAllAccordion(){
            let accordions = this.accordionData
            accordions.forEach((accordion) => {
                accordion.open = 'closed-body'
            })
        },
        calcHeight(accordion){
            return accordion.open == 'closed-body' ? '10%' : '60%' 
        },

        applyTextCompetence(){
            for(let i = 0; i < 5; i++){
                let text = this.accordionText[i][0]
                if(this.reportData.competencesArray[i] < this.reportData.competencesArray[i + 5]){
                    text = this.accordionText[i][1]
                    this.accordionData[i].title[1].competence = true
                    this.accordionData[i].title[0].competence = false
                }
                this.accordionData[i].text = text
            }
        },
        swipeHandler (direction) {
            if(direction == 'right') this.$router.push(this.pagination.beforeRoutePagination) 
            if(direction == 'left') this.$router.push(this.pagination.nextRoutePagination)
        }        
    }
}
</script>

<style lang="scss">
#competences{
    display: flex;
    flex-direction: column;
    position: relative;
    height: 100%;
}
    .container-competences{
        display: flex;
        flex-direction: column;
        height: calc(100% - 103px);

        .accordion{
            height: 10%;

        .closed-body{
            z-index: 1;
            overflow: hidden;
            // height: 0px;
            transition-duration: 500ms;

            .accordion-header{
                height: 100%;
                padding: 0 5px;
                .header-title{
                    font-size: 10px;
                    
                    .title-text{
                        font-weight: 500;
                        font-size: 15px;
                    }

                    .title-text.title-bold{
                        font-size: 15px;
                        color: #000;
                        font-weight: 700;
                    }
                }
            }
            
        }
        }
        .accordion.light{
            .accordion-header{
                background-color: #f0f0f0 ;
            }
        }
        .accordion.dark{
            .accordion-header{
                background-color: #071620 ;
            }
        }
        .accordion.open.dark, .accordion.open.light{
            .accordion-header{
                background-color: transparent;
            }
        }               
    }
@media only screen and (min-width: 900px) {
    .container-competences .accordion .closed-body .accordion-header .header-title .title-text.title-bold{font-size: 23px;}
    .container-competences .accordion .closed-body .accordion-header .header-title .title-text{font-size: 20px;}
    .accordion-content .accordion-header .header-title .title-text, .accordion-content .accordion-header .header-title .title-text .x{font-size: 21px;}
    .accordion-content .accordion-header .header-title .title-bold{font-size: 28px;}
    .accordion-content .accordion-body .body-text{
        font-size: 20px;
        line-height: 30px;
    }
}    
</style>
